<div class="iframe-container">
  <iframe [src]="url" allowfullscreen></iframe>
</div>
